module.exports = __webpack_public_path__ + "img/nepa_logo_without_text.c7fd0eaa.svg";